module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-content order-content"
  }, [_c('div', {
    staticClass: "main-width"
  }, [_c('div', {
    staticClass: "manage-center-content"
  }, [_c('div', {
    staticClass: "manage-slide"
  }, [_c('el-col', [_c('el-menu', {
    staticClass: "el-menu-vertical-demo ulsmenu",
    attrs: {
      "default-active": _vm.defaultActive,
      "default-openeds": _vm.defaultOpen
    },
    on: {
      "select": _vm.setStatus
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {}), _vm._v("订单管理\n              ")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-null"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("全部订单")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-5"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("已取消")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("待付款")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("待发货")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-3"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("已发货")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-4"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("已收货")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-6"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("交易成功")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-7"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("交易失败")])], 2), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1-8"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("售后订单")])], 2)], 2)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }]
  }, [_c('div', [_c('div', {
    staticClass: "shelves-filter-wrap"
  }, [_c('span', {
    staticClass: "shelves-input-item"
  }, [_c('label', [_vm._v("订单编号：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.orderInfoSn),
      expression: "condition.orderInfoSn"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入子订单编号"
    },
    domProps: {
      "value": (_vm.condition.orderInfoSn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.condition, "orderInfoSn", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item"
  }, [_c('label', [_vm._v("父订单号：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.orderObjectSn),
      expression: "condition.orderObjectSn"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入父订单号"
    },
    domProps: {
      "value": (_vm.condition.orderObjectSn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.condition, "orderObjectSn", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item"
  }, [_c('label', [_vm._v("下单时间：")]), _vm._v(" "), _c('span', [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "size": "mini",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions2
    },
    on: {
      "change": _vm.setTime
    },
    model: {
      value: (_vm.value7),
      callback: function($$v) {
        _vm.value7 = $$v
      },
      expression: "value7"
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item"
  }, [_c('label', [_vm._v("收件人：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.linkMan),
      expression: "condition.linkMan"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入收件人姓名"
    },
    domProps: {
      "value": (_vm.condition.linkMan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.condition, "linkMan", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item"
  }, [_c('label', [_vm._v("手机号：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.mobile),
      expression: "condition.mobile"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入收件人手机号码"
    },
    domProps: {
      "value": (_vm.condition.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.condition, "mobile", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('label', [_vm._v("商品名称：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.goodsName),
      expression: "condition.goodsName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入商品名称"
    },
    domProps: {
      "value": (_vm.condition.goodsName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.condition, "goodsName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('label', [_vm._v("自有订单号：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition.ownerOrderSn),
      expression: "condition.ownerOrderSn"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入自有订单号"
    },
    domProps: {
      "value": (_vm.condition.ownerOrderSn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.condition, "ownerOrderSn", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "shelves-filter-btn-default shelves-filter",
    on: {
      "click": _vm.init
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('span', {
    staticClass: "shelves-filter-btn-default shelves-cancel",
    on: {
      "click": _vm.clearCondition
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    staticClass: "shelves-filter-btn-default shelves-dc",
    attrs: {
      "loading": _vm.loading1
    },
    on: {
      "click": _vm.orderDetail
    }
  }, [_vm._v("订单导出")]), _vm._v(" "), _c('el-button', {
    staticClass: "shelves-filter-btn-default shelves-dc",
    attrs: {
      "loading": _vm.loading2
    },
    on: {
      "click": _vm.feightData
    }
  }, [_vm._v("运费导出")])], 1)]), _vm._v(" "), _c('table', {
    staticClass: "shelves-table shelvea-tables"
  }, [_c('thead', {
    class: _vm.searchBarFixed == true ? 'isFixed' : '',
    attrs: {
      "id": "searchBar"
    }
  }, [_vm._m(0)]), _vm._v(" "), _vm._l((_vm.orderList), function(item) {
    return _c('tbody', {
      staticClass: "order-tbody"
    }, [_vm._m(1, true), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "shelves-table-block-title no-select",
      attrs: {
        "colspan": "8"
      }
    }, [_c('span', [_vm._v("订单编号：" + _vm._s(item.orderSn))]), _vm._v(" "), _c('span', [_vm._v("下单时间：" + _vm._s(item.createTime))]), _vm._v(" "), _c('span', [_vm._v("收货人：" + _vm._s(item.linkMan))]), _vm._v(" "), _c('span', [_vm._v("收货人电话：" + _vm._s(item.mobile))])])]), _vm._v(" "), _vm._l((item.listDetail), function(detail, index) {
      return _c('tr', {
        staticClass: "order-table-item"
      }, [_c('td', {
        staticClass: "order-table-image"
      }, [_c('div', {
        staticClass: "order-table-image-wrap"
      }, [_c('img', {
        attrs: {
          "src": _vm.imgAddress + detail.navigateImg1
        },
        on: {
          "error": function($event) {
            return _vm.error(1)
          }
        }
      }), _vm._v(" "), (item.isOwns > 0) ? _c('img', {
        staticStyle: {
          "width": "22px",
          "height": "22px",
          "position": "absolute",
          "z-index": "100",
          "top": "initial",
          "left": "0"
        },
        attrs: {
          "src": require("../assets/img/is_owns.png"),
          "alt": ""
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_c('div', {
        staticClass: "order-goods-name",
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v(_vm._s(detail.goodsName))]), _vm._v(" "), _c('div', {
        staticClass: "order-default-font order-guige",
        staticStyle: {
          "color": "#999"
        }
      }, [_vm._v(_vm._s(detail.specName))]), _vm._v(" "), _c('div', {
        staticClass: "order-default-font order-guige",
        staticStyle: {
          "color": "#999"
        }
      }, [_vm._v("货号：" + _vm._s(detail.productBn))]), _vm._v(" "), _c('div', {
        staticClass: "order-default-font order-guige",
        staticStyle: {
          "word-break": "break-all"
        }
      }, [_vm._v("自有订单号：" + _vm._s(detail.ownerOrderSn))]), _vm._v(" "), _c('div', {
        staticClass: "order-default-font order-guige",
        staticStyle: {
          "word-break": "break-all"
        }
      }, [_vm._v("发货时间：" + _vm._s(detail.deliverTime))])])]), _vm._v(" "), _c('td', {
        staticClass: "order-default-font"
      }, [_vm._v("¥" + _vm._s(detail.cooperatePrice / 100))]), _vm._v(" "), _c('td', {
        staticClass: "order-default-font"
      }, [_vm._v(_vm._s(detail.quantity))]), _vm._v(" "), _c('td', [(detail.isContain == 0) ? [_vm._v("不开票")] : _vm._e(), _vm._v(" "), (detail.isContain == 1) ? [_vm._v("开票")] : _vm._e()], 2), _vm._v(" "), (detail.status == 1 || detail.status == 5 || detail.status == 6 || detail.status == 7) ? _c('td', {
        staticClass: "order-toDetail"
      }, [_c('a', {
        staticClass: "cursor-pointer"
      }, [_vm._v("无法售后")])]) : (detail.applyNum == 0) ? _c('td', {
        staticClass: "order-toDetail"
      }, [_c('router-link', {
        staticClass: "font-color-orange cursor-pointer",
        attrs: {
          "tag": "a",
          "target": "_blank",
          "to": {
            name: 'AfterSale',
            query: {
              detailId: detail.orderDetailId,
              orderId: item.orderId,
              status: item.listDetail[0].status
            }
          }
        }
      }, [_vm._v("申请售后")])], 1) : (detail.applyNum < detail.quantity) ? _c('td', {
        staticClass: "order-toDetail"
      }, [_c('router-link', {
        staticClass: "font-color-orange cursor-pointer",
        attrs: {
          "tag": "a",
          "target": "_blank",
          "to": {
            name: 'AfterSale',
            query: {
              detailId: detail.orderDetailId,
              orderId: item.orderId,
              status: item.listDetail[0].status
            }
          }
        }
      }, [_vm._v("已申请售后" + _vm._s(detail.applyNum) + "件")])], 1) : _c('td', {
        staticClass: "order-toDetail"
      }, [_c('a', {
        staticClass: "cursor-pointer"
      }, [_vm._v("已售后")])]), _vm._v(" "), _c('td', [(detail.status == 1) ? _c('div', {
        staticClass: "font-color-orange"
      }, [_vm._v("待付款")]) : (detail.status == 2) ? _c('div', {
        staticClass: "font-color-orange"
      }, [_vm._v("待发货")]) : (detail.status == 3) ? _c('div', {
        staticClass: "font-color-orange"
      }, [_vm._v("已发货")]) : (detail.status == 4) ? _c('div', {
        staticClass: "font-color-orange"
      }, [_vm._v("已发货")]) : (detail.status == 5) ? _c('div', {
        staticClass: "font-color-orange"
      }, [_vm._v("已取消")]) : (detail.status == 6) ? _c('div', {
        staticClass: "font-color-orange"
      }, [_vm._v("交易成功")]) : (detail.status == 7) ? _c('div', {
        staticClass: "font-color-orange"
      }, [_vm._v("交易失败")]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "order-item-time"
      }, [_vm._v(_vm._s(detail.statusTime))])]), _vm._v(" "), (index == 0) ? _c('td', {
        attrs: {
          "rowspan": item.listDetail.length
        }
      }, [_c('div', [_vm._v(_vm._s(item.totalCooperatePrice / 100))]), _vm._v(" "), _c('div', {
        staticClass: "order-item-time"
      }, [_vm._v("（含运费：¥" + _vm._s(item.freight / 100) + ")")]), _vm._v(" "), (item.remark != '') ? _c('div', [_c('el-tooltip', {
        staticClass: "item",
        attrs: {
          "effect": "dark",
          "content": "Top Center 提示文字",
          "placement": "top"
        }
      }, [_c('div', {
        attrs: {
          "slot": "content"
        },
        slot: "content"
      }, [_vm._v(_vm._s(item.remark))]), _vm._v(" "), _c('i', {
        staticClass: "el-icon-information"
      })])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (index == 0) ? _c('td', {
        staticClass: "order-toDetail",
        attrs: {
          "rowspan": item.listDetail.length
        }
      }, [_c('router-link', {
        staticClass: "font-color-orange cursor-pointer",
        attrs: {
          "tag": "a",
          "target": "_blank",
          "to": {
            name: 'OrderDetail',
            query: {
              orderId: item.orderId,
              orderSn: item.orderSn
            }
          }
        }
      }, [_vm._v("查看订单")])], 1) : _vm._e()])
    })], 2)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.condition.pageNum,
      "total": _vm.total,
      "page-size": 10
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.condition, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.condition, "pageNum", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show),
      expression: "!show"
    }]
  }, [_c('div', [_c('div', {
    staticClass: "shelves-filter-wrap"
  }, [_c('span', {
    staticClass: "shelves-input-item"
  }, [_c('label', [_vm._v("售后单号：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.afsCondition.afterSn),
      expression: "afsCondition.afterSn"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入订单编号"
    },
    domProps: {
      "value": (_vm.afsCondition.afterSn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.afsCondition, "afterSn", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item"
  }, [_c('label', [_vm._v("订单单号：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.afsCondition.orderInfoSn),
      expression: "afsCondition.orderInfoSn"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入订单编号"
    },
    domProps: {
      "value": (_vm.afsCondition.orderInfoSn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.afsCondition, "orderInfoSn", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item order-range-time"
  }, [_c('label', [_vm._v("订单状态：")]), _vm._v(" "), _c('span', [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.afsCondition.status),
      callback: function($$v) {
        _vm.$set(_vm.afsCondition, "status", $$v)
      },
      expression: "afsCondition.status"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('label', [_vm._v("商品名称：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.afsCondition.goodsName),
      expression: "afsCondition.goodsName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入商品名称"
    },
    domProps: {
      "value": (_vm.afsCondition.goodsName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.afsCondition, "goodsName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item"
  }, [_c('label', [_vm._v("手机号码：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.afsCondition.mobile),
      expression: "afsCondition.mobile"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入收件人手机号码"
    },
    domProps: {
      "value": (_vm.afsCondition.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.afsCondition, "mobile", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item order-range-time"
  }, [_c('label', [_vm._v("下单时间：")]), _vm._v(" "), _c('span', [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "placeholder": "选择日期范围",
      "picker-options": _vm.pickerOptions2
    },
    on: {
      "change": _vm.setAfsTime
    },
    model: {
      value: (_vm.value6),
      callback: function($$v) {
        _vm.value6 = $$v
      },
      expression: "value6"
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('label', [_vm._v("自有售后单：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.afsCondition.ownerAfterOrderSn),
      expression: "afsCondition.ownerAfterOrderSn"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入自有售后单号"
    },
    domProps: {
      "value": (_vm.afsCondition.ownerAfterOrderSn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.afsCondition, "ownerAfterOrderSn", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "shelves-input-item",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('label', [_vm._v("自有订单号：")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.afsCondition.ownerOrderSn),
      expression: "afsCondition.ownerOrderSn"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入自有订单号"
    },
    domProps: {
      "value": (_vm.afsCondition.ownerOrderSn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.afsCondition, "ownerOrderSn", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "shelves-filter-btn-default shelves-filter",
    on: {
      "click": _vm.afsInit
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('span', {
    staticClass: "shelves-filter-btn-default shelves-cancel",
    on: {
      "click": _vm.clearAfsCondition
    }
  }, [_vm._v("重置")])])]), _vm._v(" "), _c('table', {
    staticClass: "shelves-table"
  }, [_c('thead', {
    class: _vm.searchBarFixed == true ? 'isFixeds' : '',
    attrs: {
      "id": "searchBar"
    }
  }, [_vm._m(2)]), _vm._v(" "), _vm._l((_vm.afsList), function(item) {
    return _c('tbody', {
      staticClass: "order-tbody"
    }, [_vm._m(3, true), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "shelves-table-block-title no-select",
      attrs: {
        "colspan": "7"
      }
    }, [_c('span', [_vm._v("售后单号：" + _vm._s(item.afterSn))]), _vm._v(" "), _c('span', [_vm._v("订单号：" + _vm._s(item.orderInfoSn))]), _vm._v(" "), _c('span', [_vm._v("下单时间：" + _vm._s(item.orderCreateTime))]), _vm._v(" "), (item.orderStatus == 2) ? _c('span', [_vm._v("订单状态：待发货")]) : (item.status == 3) ? _c('span', [_vm._v("订单状态：已发货")]) : (item.status == 4) ? _c('span', [_vm._v("订单状态：已收货")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("收货人电话：" + _vm._s(item.mobile))]), _vm._v(" "), _c('span', [_vm._v("售后时间：" + _vm._s(item.afterCreateTime))]), _vm._v(" "), _c('span', [_vm._v("自有订单号：" + _vm._s(item.ownerOrderSn))]), _vm._v(" "), _c('span', [_vm._v("自有售后单号：" + _vm._s(item.ownerAfterOrderSn))])])]), _vm._v(" "), _c('tr', {
      staticClass: "order-table-item"
    }, [_c('td', {
      staticClass: "order-table-image"
    }, [_c('div', {
      staticClass: "order-table-image-wrap"
    }, [_c('img', {
      attrs: {
        "src": _vm.imgAddress + item.goodsImage
      },
      on: {
        "error": function($event) {
          return _vm.error(1)
        }
      }
    }), _vm._v(" "), (item.selfStoreId > 0) ? _c('img', {
      staticStyle: {
        "width": "22px",
        "height": "22px",
        "position": "absolute",
        "z-index": "100",
        "top": "initial",
        "left": "0"
      },
      attrs: {
        "src": require("../assets/img/is_owns.png"),
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_c('div', {
      staticClass: "order-goods-name",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('div', {
      staticClass: "order-default-font order-guige",
      staticStyle: {
        "color": "#999"
      }
    }, [_vm._v(_vm._s(item.specName))])])]), _vm._v(" "), _c('td', {
      staticClass: "order-default-font"
    }, [_c('div', [_vm._v("¥" + _vm._s(item.refundFee / 100))]), _vm._v(" "), _c('div', {
      staticClass: "order-item-time"
    }, [_vm._v("（含运费：¥" + _vm._s(item.refundPostage / 100) + ")")])]), _vm._v(" "), _c('td', {
      staticClass: "order-default-font"
    }, [_vm._v(_vm._s(item.refundAmount))]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(item.applicationReason))])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(item.refundType))])]), _vm._v(" "), _c('td', [(item.status == 1) ? _c('div', [_vm._v("待处理")]) : (item.status == 2) ? _c('div', [_vm._v("平台同意")]) : _vm._e(), _vm._v(" "), (item.status == 3) ? _c('div', [_vm._v("已完成退款")]) : _vm._e(), _vm._v(" "), (item.status == 4) ? _c('div', [_vm._v("拒绝")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "order-toDetail"
    }, [_c('router-link', {
      staticClass: "font-color-orange cursor-pointer",
      attrs: {
        "tag": "a",
        "target": "_blank",
        "to": {
          name: 'AfterSale',
          query: {
            status: item.status,
            id: item.afterSalesId,
            detailId: item.orderDetailId
          }
        }
      }
    }, [_vm._v("查看售后详情")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "font-color-orange cursor-pointer",
      staticStyle: {
        "margin-right": "0"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.addOwnerAfterSn(item.afterSn, item.ownerAfterOrderSn)
        }
      }
    }, [_vm._v("补充自有售后单号")])], 1)])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.afsCondition.pageNum,
      "total": _vm.afsTotal,
      "page-size": 10
    },
    on: {
      "current-change": _vm.handleAsfCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.afsCondition, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.afsCondition, "pageNum", $event)
      }
    }
  })], 1)])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "自有售后单号",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "单号",
      "label-width": "60px"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: (_vm.newOwnerAfterOrderSn),
      callback: function($$v) {
        _vm.newOwnerAfterOrderSn = $$v
      },
      expression: "newOwnerAfterOrderSn"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer charge-dialog-btn",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "border-color": "#ffa726",
      "color": "#ffa726"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#ffa726",
      "border-color": "#ffa726"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addOwnerAfterSnFn
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("商品信息")]), _vm._v(" "), _c('th', [_vm._v("最终结算价")]), _vm._v(" "), _c('th', [_vm._v("数量")]), _vm._v(" "), _c('th', [_vm._v("是否带票")]), _vm._v(" "), _c('th', [_vm._v("售后")]), _vm._v(" "), _c('th', [_vm._v("状态")]), _vm._v(" "), _c('th', [_vm._v("包裹总额")]), _vm._v(" "), _c('th', [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "self-tbody-space",
    attrs: {
      "colspan": "8"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("商品信息")]), _vm._v(" "), _c('th', [_vm._v("退款金额")]), _vm._v(" "), _c('th', [_vm._v("退货数量")]), _vm._v(" "), _c('th', [_vm._v("退款理由")]), _vm._v(" "), _c('th', [_vm._v("售后类型")]), _vm._v(" "), _c('th', [_vm._v("售后状态")]), _vm._v(" "), _c('th', [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "self-tbody-space",
    attrs: {
      "colspan": "7"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-118a7d06","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order.vue
// module id = 515
// module chunks = 1